import { jtbdDismissInfo } from '@fiverr-private/jtbd_sdk';
import { Notification, ValidNotification } from '../../types/notifications';
import { Order, OrderStatus } from '../../types/gqlTypes';

const RELEVANT_PF_TYPES = ['new_order_message', 'delivered'];

export const selectOrderUnreadNotification = (
    notifications: Notification[],
    ordersByEncryptedId: Record<string, Order>,
    deliveredOrder?: Order,
    jtbdDismissInfo?: jtbdDismissInfo
): ValidNotification | undefined => {
    const isValidNotification = (notification: Notification): notification is ValidNotification => {
        const {
            is_read: isRead,
            msg_params: { order_id: orderId },
            sub_type: subType,
        } = notification;

        return !isRead && !!orderId && RELEVANT_PF_TYPES.includes(subType) && orderId in ordersByEncryptedId;
    };

    const shouldSearchForDeliveredOrders = !!deliveredOrder;
    let latestOrderNotification: ValidNotification | undefined;
    const dismissedMap = new Map(jtbdDismissInfo?.args?.map(([id, updatedAt]) => [id, Number(updatedAt)]));

    for (const notification of notifications) {
        if (!isValidNotification(notification)) {
            continue;
        }

        if (notification.msg_params.order_id) {
            const dismissedOrderUpdatedAt = dismissedMap.get(notification.msg_params.order_id);

            if (dismissedOrderUpdatedAt) {
                if (notification.updated_at > dismissedOrderUpdatedAt) {
                    if (jtbdDismissInfo?.callback) {
                        void jtbdDismissInfo?.callback(
                            'order_updates',
                            notification.msg_params.order_id,
                            dismissedOrderUpdatedAt
                        );
                    }
                } else {
                    continue;
                }
            }
        }

        if (ordersByEncryptedId[notification.msg_params.order_id].status === OrderStatus.Delivered) {
            latestOrderNotification = notification;
            break;
        }

        if (!latestOrderNotification) {
            latestOrderNotification = notification;

            if (!shouldSearchForDeliveredOrders) {
                break;
            }
        }
    }

    return latestOrderNotification;
};
